import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=677f3a39&lang=pug"
import script from "./BaseRow.vue?vue&type=script&lang=js"
export * from "./BaseRow.vue?vue&type=script&lang=js"
import style0 from "./BaseRow.vue?vue&type=style&index=0&id=677f3a39&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports